import { WSElementProps } from "@wingspanhq/fe-component-library";
import { Tabs } from "../../../../components/Tabs";
import { usePayeeRowsSummaryQuery } from "../../../../query/search/payee/queries/usePayeeRowsSummaryQuery";
import {
  PayerPayeeEngagementSearchableStatus,
  PayerPayeeSearchableRequirementsStatus
} from "../../../../services/search";
import { useIsEngagementsActive } from "../../../../shared/hooks/useIsEngagementsActive";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_COMPLETE_PATH,
  PAYEES_INCOMPLETE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH
} from "../../utils";

export const DashboardTabs: React.FC<WSElementProps> = props => {
  const isEngagementsActive = useIsEngagementsActive();

  // Query for all payees (excluding inactive)
  const queryAllPayees = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: {
        "!=": PayerPayeeEngagementSearchableStatus.Inactive
      }
    }
  });

  // Query for not signed up payees
  const queryNotSignedUp = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.NotSignedUp
    }
  });

  // Query for incomplete payees
  const queryIncomplete = usePayeeRowsSummaryQuery({
    filter: {
      searchableRequirementsStatus:
        PayerPayeeSearchableRequirementsStatus.Incomplete
    }
  });

  // Query for complete payees
  const queryComplete = usePayeeRowsSummaryQuery({
    filter: {
      searchableRequirementsStatus:
        PayerPayeeSearchableRequirementsStatus.Complete
    }
  });

  // Query for archived payees
  const queryArchived = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.Inactive
    }
  });

  return (
    <Tabs
      {...props}
      tabs={[
        {
          label: "Active",
          path: PAYEES_ALL_PATH,
          badge: queryAllPayees.data?.listSize
        },
        {
          label: "Not signed up",
          path: PAYEES_NOT_SIGNED_UP_PATH,
          badge: queryNotSignedUp.data?.listSize
        },
        {
          label: "Incomplete",
          path: PAYEES_INCOMPLETE_PATH,
          badge: queryIncomplete.data?.listSize
        },
        {
          label: "Complete",
          path: PAYEES_COMPLETE_PATH,
          badge: queryComplete.data?.listSize
        },
        {
          label: "Archived",
          path: PAYEES_ARCHIVED_PATH,
          badge: queryArchived.data?.listSize
        }
      ]}
    />
  );
};
